<template>
  <v-select
    class="payment-type-select"
    v-bind="$attrs"
    item-text="text"
    item-value="value"
    :value="value"
    :items="items"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {},
  },
  computed: {
    items() {
      return [
        { text: this.$t('common.no-selected'), value: 'null' },
        { text: this.$t('investor-report.paymentOfficial'), value: 1 },
        { text: this.$t('investor-report.paymentUnofficial'), value: 0 },
      ];
    },
  },
};
</script>

<style lang="scss">
.payment-type-select.v-input--dense {
  .v-select__selections {
    font-size: 12px;
  }
}
</style>
